var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-404"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("../assets/img/header/logo.png"),"alt":""}})]),_c('div',{staticClass:"title"},[_c('div',{staticClass:"info"},[_c('h1',[_vm._v(" ESTAMOS A PREPARAR O CAFÉ DA SORTE PARA SI ")])])])])
}]

export { render, staticRenderFns }